<script>
  import { onMount, onDestroy } from "svelte";
  import { fade } from "svelte/transition";
  import { sineInOut } from "svelte/easing";

  const images = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(
    (i) => `/images/image_${i}.jpg`
  );

  let currentImages = [images[0], images[1]];

  const loadImage = (url) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        return resolve(url);
      };
      image.onerror = () => {
        return reject(url);
      };
      image.src = url;
    });
  };

  let interval = null;
  let nextToChange = 0;

  onMount(() => {
    Promise.all(
      images
        .filter((image) => !currentImages.includes(image))
        .map((image) => loadImage(image))
    ).then(
      (interval = setInterval(() => {
        const toChooseFrom = images.filter(
          (image) =>
            image !== currentImages[nextToChange] &&
            image !== currentImages[(nextToChange + 1) % 2]
        );
        const nextIndex =
          toChooseFrom[Math.floor(Math.random() * toChooseFrom.length)];
        currentImages[nextToChange] = nextIndex;
        nextToChange = (nextToChange + 1) % 2;
      }, 5000))
    );
  });

  onDestroy(() => {
    if (interval !== null) {
      clearInterval(interval);
      interval = null;
    }
  });
</script>

<div class="photos">
  <figure class="first">
    {#each images as image}
      {#if image == currentImages[0]}
        <img
          transition:fade={{ duration: 1000, easing: sineInOut }}
          src={image}
          alt="A cute picture of Kelly and Phil"
        />
      {/if}
    {/each}
  </figure>
  <figure class="second">
    {#each images as image}
      {#if image == currentImages[1]}
        <img
          transition:fade={{ duration: 1000, easing: sineInOut }}
          src={image}
          alt="Another cute picture of Kelly and Phil"
        />
      {/if}
    {/each}
  </figure>
</div>

<style>
  .photos {
    display: flex;
    width: 150%;
    margin-left: -25%;
    margin-bottom: 40px;
  }
  figure {
    display: block;
    position: relative;
    width: 50%;
    padding-top: 37.5%;
    /* padding: 5px; */
    margin: 0;
    border: 1px solid rgba(0, 0, 0, 0.4);
    background-color: #fff;
    -webkit-box-shadow: 2px 5px 8px 0px rgba(0, 0, 0, 0.2);
    box-shadow: 2px 5px 8px 0px rgba(0, 0, 0, 0.2);
  }
  figure.first {
    transform: rotate(-12deg);
  }
  figure.second {
    transform: rotate(12deg);
  }
  figure img {
    position: absolute;
    top: 0;
    padding: 5px;
    width: 100%;
    display: block;
  }
</style>
